import { useTranslation } from 'next-i18next/pages';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';

import { ReactComponent as TopCompanyBadge } from '@public/assets/top-company.svg';

interface TopCompanyProps {
  namespace?: string;
}

const TopCompany: React.FC<TopCompanyProps> = ({ namespace = 'landingPage' }) => {
  const { t } = useTranslation(namespace, { keyPrefix: 'header' });
  const { isPraxia } = useFlavorFromRoute();
  return (
    <>
      {!isPraxia && (
        <div className='mt-7 flex flex-col items-center justify-center gap-2 bg-input py-3 text-center text-sm font-normal text-default/80'>
          <TopCompanyBadge className='mx-auto w-6/12 sm:w-[180px] md:mx-0' data-testid='top-company-badge' />
          <span>{t('awardAsTopCareerPlatform')}</span>
        </div>
      )}
    </>
  );
};

export default TopCompany;
